import type { SVGProps } from 'react'

/**
 * Crane icon — the symbol the Engineering Agents shipped with in
 * the original dock. Hoisted out of `components/engineering-agent/`
 * so the nav-v4 menu entry and the new `/engineering` page can
 * share it.
 */
export function CraneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M3.5 21h6" />
      <path d="M6.5 21V5" />
      <path d="M3 5h17" />
      <path d="M6.5 2l9.5 3" />
      <path d="M16.5 5v6.5" />
      <path d="M15.5 11.5h2" />
    </svg>
  )
}
